import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import {faCheckCircle } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-absentee-bidding',
  imports: [ButtonModule, DialogModule, FontAwesomeModule],
  templateUrl: './absentee-bidding.component.html',
  styleUrl: './absentee-bidding.component.scss'
})
export class AbsenteeBiddingComponent {

    @Input() visible = false;
  @Output() close = new EventEmitter<void>();

faCheckCircle = faCheckCircle;

  onClose() {
    console.log('close');
    this.close.emit();
  }

}
